import * as React from 'react';
import FormCheckbox from 'cl-form/FormCheckbox';
import AmazonAccountSelect from '../DialogComponents/AmazonAccountSelect';
import * as _ from 'lodash';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import AmazonSitesSelect from '../DialogComponents/AmazonSitesSelect';
import {MIN_WIDTH} from 'cl-form/FormSelect';
import {getAmazonSellerFirstSite, getSellerSites} from '../../../../MyAccount/AmazonListings/amazonListingHelpers';
import {change} from 'redux-form';
import {useSelector, useDispatch} from 'react-redux';
import {withRouter, WithRouterProps} from 'react-router';
import {StoreState} from '../../../../App/initialStore';
import {getFormValues} from 'redux-form';

export interface ImportProductsFromAmazonFormData {
  sellerId: string;
  ignoreInactive: boolean;
  firstPrioritySite: string;
  secondPrioritySite: string;
}

export type ImportProductsFromAmazonDialogProps = SpecificFormDialogProps<ImportProductsFromAmazonFormData>;

const ImportProductsFromAmazonDialog: React.FunctionComponent<
  ImportProductsFromAmazonDialogProps & WithRouterProps
> = ({...props}) => {
  const {options, sellerId} = useSelector((state: StoreState) => {
    const formValues = getFormValues(GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON)(state);
    const sellerId = (formValues && (formValues as any).sellerId) || _.first(_.keys(state.accountPage.amazonAccounts));
    return getSellerSites(sellerId);
  });

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      change(GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON, 'firstPrioritySite', getAmazonSellerFirstSite(sellerId))
    );
    dispatch(change(GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON, 'secondPrioritySite', null));
  }, [sellerId]);

  return (
    <FormDialog<ImportProductsFromAmazonFormData>
      formName={GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON}
      title="Import products from Amazon"
      text="Listings with SKU's already in your Products Catalog will be linked to existing products. Products will be created using the SKU (custom label) in your listings. If you don't have SKU's on your listings, we will autogenerate SKU's for your Products Catalog upon import."
      initialValues={{
        sellerId: sellerId,
        ignoreInactive: true,
        firstPrioritySite: getAmazonSellerFirstSite(sellerId),
        secondPrioritySite: null,
      }}
      fields={[
        {component: AmazonAccountSelect, name: 'sellerId', label: 'Amazon account'},
        {
          component: AmazonSitesSelect,
          name: 'firstPrioritySite',
          label: 'First priority',
          instructionText: 'Listings with the same SKU from different sites will be handled by this priority:',
          explanationText:
            "The product in your catalog will be created based on listing's data from this site when there are listings on several Amazon sites with the same SKU.",
          explanationTooltip: true,
          props: {
            minWidth: MIN_WIDTH.MEDIUM,
            options,
          },
        },
        {
          component: AmazonSitesSelect,
          name: 'secondPrioritySite',
          label: 'Second priority',
          instructionText: 'Then all other sites',
          instructionPosition: 'after',
          explanationText:
            "This site's listing data will be used for the catalog product, if a SKU does NOT exist in the First Priority site, but exists in listings on other sites.",
          explanationTooltip: true,
          optional: true,
          props: {
            minWidth: MIN_WIDTH.MEDIUM,
            options,
          },
        },
        {component: FormCheckbox, name: 'ignoreInactive', label: 'Ignore inactive listings', props: {disabled: true}},
      ]}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          lastActionColor="primary"
        />
      }
      {...props}
    />
  );
};

export default withRouter(ImportProductsFromAmazonDialog);
